const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggN2E1IDUgMCAwIDEgMCAxMGgtNHYtMmg0YTMgMyAwIDAgMCAwLTZoLTRWN2g0em0tOCAwdjJINmEzIDMgMCAwIDAgMCA2aDR2Mkg2QTUgNSAwIDAgMSA2IDdoNHptNyA0djJIN3YtMmgxMHoiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  M as default
};
//# sourceMappingURL=link-d1c24cbb.mjs.map
